// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Dppd","col":"styles_col__3edMs","actions":"styles_actions__eBGCC","conflict":"styles_conflict__1c60k"};